import { useState, useEffect } from "react";

// Funzioni per codifica e decodifica base64 (Unicode-safe)
function encodeBase64(str: string): string {
  if (typeof window === "undefined") return "";
  return window.btoa(
    new TextEncoder()
      .encode(str)
      .reduce((acc, byte) => acc + String.fromCharCode(byte), ""),
  );
}

function decodeBase64(str: string): string {
  if (typeof window === "undefined") return "";
  const binary = window.atob(str);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      if (!item) return initialValue;
      const decoded = decodeBase64(item);
      return JSON.parse(decoded) as T;
    } catch (error) {
      console.warn("Error reading localStorage key “" + key + "”:", error);
      return initialValue;
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const encoded = encodeBase64(JSON.stringify(storedValue));
      window.localStorage.setItem(key, encoded);
    } catch (error) {
      console.warn("Error setting localStorage key “" + key + "”:", error);
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue] as const;
}
